"use client"

import { Phone, MessageCircle } from "lucide-react"

export function FloatingButtons() {
  const phoneNumber = "5551983204177"

  return (
    <>
      {/* WhatsApp Float Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=Olá! Gostaria de saber mais sobre os serviços da Void Agência.`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float flex items-center justify-center"
        aria-label="Contato via WhatsApp"
      >
        <MessageCircle size={24} />
      </a>

      {/* Phone Float Button */}
      <a
        href={`tel:+${phoneNumber}`}
        className="phone-float flex items-center justify-center"
        aria-label="Ligar para Void Agência"
      >
        <Phone size={20} />
      </a>
    </>
  )
}
